module.exports = __webpack_public_path__ + "media/trophy/trophy-02-e715bbb4.svg";